import type { Product } from '../../../data/product';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const Description: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Description',
  minWidth: 200,
  accessorFn: (product) => product.description,
});
